import React from 'react';
import nodejs from '../../assets/logo/nodejs.png';
import expressjs from '../../assets/logo/expressjs.png';
import mongodb from '../../assets/logo/mongodb.png';
import heroku from '../../assets/logo/heroku.png';
import railway from '../../assets/logo/railway.png';
import vercel from '../../assets/logo/vercel.png';
import render from '../../assets/logo/render.png';

const BackEndSkills = () => {
    return (
        <div data-aos="fade-up" data-aos-duration="2000">
            <div className="flex items-center mt-20 mb-4">
                <span className="h-0.5 bg-accent w-24"></span>
                <p className="ml-3">Back-end skills & tools</p>
            </div>
            {/* -----------back end skills section----------- */}
            <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-3">
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={nodejs} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Node JS</h2>
                            <p>My progress in Node JS</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="50"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={expressjs} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Express JS</h2>
                            <p>My progress in Express JS</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="50"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={mongodb} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">MongoDB</h2>
                            <p>MongoDB CRUD operation</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="60"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={heroku} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Heroku</h2>
                            <p>My progress in Heroku</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="90"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={railway} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Railway.app</h2>
                            <p>My progress in Railway</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="90"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={vercel} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Vercel</h2>
                            <p>My progress in Vercel</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="90"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={render} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Render</h2>
                            <p>My progress in Render</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="90"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BackEndSkills;
